import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@missionlabs/react'
import { WhatsappIcon } from '@missionlabs/react/circleloop'
import { ChatIconRegular } from '@missionlabs/react/zeta'
import { ActivityFooterMessageType } from 'features/activity/types'
import { FC, startTransition } from 'react'
import { useTranslation } from 'react-i18next'

import { useActivityFooterState } from './hooks/useActivityFooterState'

export interface ActivityFeedMessagingMenuProps {
    isSMSEnabled: boolean
    isWhatsAppEnabled: boolean
}

export const ActivityFeedMessagingMenu: FC<ActivityFeedMessagingMenuProps> = ({
    isSMSEnabled,
    isWhatsAppEnabled
}: ActivityFeedMessagingMenuProps) => {
    const { t } = useTranslation()
    const { onOpen, setMessageType } = useActivityFooterState()

    const handleOpen = (type: ActivityFooterMessageType) => {
        // Mount the footer as a transition so its effects don't pile onto the
        // synchronous update chain of the menu item click (PL-700)
        startTransition(() => {
            setMessageType(type)
            onOpen()
        })
    }

    return (
        <Menu variant="compact">
            <MenuButton as={IconButton} variant="ghost" aria-label="Messaging Menu">
                <ChatIconRegular />
            </MenuButton>
            <MenuList>
                {isSMSEnabled && (
                    <MenuItem
                        aria-label={t('messaging.sendSMS')}
                        icon={<ChatIconRegular />}
                        onClick={() => handleOpen(ActivityFooterMessageType.SMS)}
                    >
                        {t('messaging.sendSMS')}
                    </MenuItem>
                )}
                {isWhatsAppEnabled && (
                    <MenuItem
                        aria-label={t('messaging.sendWhatsApp')}
                        icon={<WhatsappIcon boxSize="22px" />}
                        onClick={() => handleOpen(ActivityFooterMessageType.WhatsApp)}
                    >
                        {t('messaging.sendWhatsApp')}
                    </MenuItem>
                )}
            </MenuList>
        </Menu>
    )
}
